import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export default function getDatesInRange(startDate, endDate, format = 'DD/MM/YYYY', difference = 'day', locale = null) {
  if (locale) {
    const begin = dayjs(startDate).locale(locale).utc()
    const end = dayjs(endDate).locale(locale).utc()
    const diff = begin.diff(end, difference)

    const differenceLength = Math.abs(diff) + 1
    const isValidNumber = differenceLength > 0
    const arrayLength = isValidNumber ? differenceLength : 0

    const dates = Array.from(Array(arrayLength)).map((_, index) => {
      if (difference === 'quarter') {
        return begin
          .add(index * 3, 'month')
          .locale(locale)
          .utc()
          .format(format)
      }
      return begin.add(index, difference).locale(locale).utc().format(format)
    })
    return dates
  }

  const begin = dayjs(startDate).utc()
  const end = dayjs(endDate).utc()
  const diff = begin.diff(end, difference)

  const differenceLength = Math.abs(diff) + 1
  const isValidNumber = differenceLength > 0
  const arrayLength = isValidNumber ? differenceLength : 0

  const dates = Array.from(Array(arrayLength)).map((_, index) => {
    if (difference === 'quarter') {
      return begin
        .add(index * 3, 'month')
        .utc()
        .format(format)
    }
    return begin.add(index, difference).utc().format(format)
  })
  return dates
}
